import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, connect, useSelector } from 'react-redux';
import { initLogoutResp, setLogout } from 'modules/apiUserSaga';
import { setLoginInfo } from 'modules/userState';
import RouteContainer from 'common/RouteContainer';
import RouteChangeTracker from 'common/RouteChangeTracker';
import Loader from 'shared/view/Loader';

const AUTO_LOGOUT_TIME = 30; // 분
const TIMEOUT = (process.env.REACT_APP_AUTO_LOGOUT_TIME || AUTO_LOGOUT_TIME) * 60 * 1000; // 분 * 초 * 1000 (밀리초)

const App = ({ initLogoutResp, setLoginInfo }) => {
  //
  const tmrId = useRef(-1);
  const dispatch = useDispatch();

  const loadingState = useSelector((state) => state.loadingState);
  const [currentLoading, setCurrentLoading] = useState(false);

  const autoLogout = () => {
    dispatch(setLogout(window.sessionStorage.getItem('USER_ID')));
    initLogoutResp();
    window.sessionStorage.clear();
    window.location.replace('/intro');
    if (tmrId.current > -1) {
      clearTimeout(tmrId.current);
      tmrId.current = -1;
    }
  };

  const addEvents = () => {
    ['click', 'keydown', 'scroll'].forEach((evt) => {
      window.addEventListener(evt, (e) => {
        if (tmrId.current > -1) {
          clearTimeout(tmrId.current);
          tmrId.current = -1;
        }
        const token = sessionStorage.getItem('TOKEN');
        if ((token && token.length > 0) || e.target.innerText === '로그인') {
          tmrId.current = setTimeout(() => {
            // reactAlert({ message: '세션 연결이 종료되었습니다.' }, autoLogout);
            autoLogout();
            // window.location.replace(`/error/401`);
          }, TIMEOUT);
        }
      });
    });
  };

  const removeEvents = () => {
    ['click', 'keydown', 'scroll'].forEach((evt) => {
      window.removeEventListener(evt, () => {
        if (tmrId.current > -1) {
          autoLogout();
        }
      });
    });
  };

  useEffect(() => {
    // 토큰 정보 저장 (refresh)
    //
    const token = window.sessionStorage.getItem('TOKEN');
    if (token && token.trim().length > 0) {
      setLoginInfo({
        id: window.sessionStorage.getItem('USER_ID'),
        nm: window.sessionStorage.getItem('PRVC_GNRL_NM'),
        code: window.sessionStorage.getItem('US_CODE'),
        token: window.sessionStorage.getItem('TOKEN'),
      });
      if (tmrId.current > -1) {
        clearTimeout(tmrId.current);
        tmrId.current = -1;
      }
      tmrId.current = setTimeout(() => {
        console.log('addEvt2');
        autoLogout();
      }, TIMEOUT);
    }
    //
    removeEvents();
    addEvents();
    //
    return () => {
      window.onbeforeunload = null;
      removeEvents();
    };
  }, []);

  useEffect(() => {
    if (loadingState) {
      const values = Object.values(loadingState).some((el) => el);
      setCurrentLoading(values);
    }
  }, [loadingState]);

  //
  return (
    <>
      {currentLoading ? <Loader type="spinningBubbles" color="black" /> : ''}
      <RouteContainer />
    </>
  );
};

export default connect(null, { initLogoutResp, setLoginInfo })(App);
